import { MapPin } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { siteInfo } from '../../data/mock';

export const ContactAddress = () => (
<Card data-testid="contact-address-card" className="contact-address bg-gradient-to-br from-gray-900 to-black border-2 border-red-900/40 mb-12">
              <CardContent className="pt-8">
                <div className="flex items-start space-x-4">
                  <div className="bg-gradient-to-br from-yellow-600 to-yellow-800 p-4 rounded-xl">
                    <MapPin className="w-8 h-8 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-yellow-400 mb-3">Adresse en Guadeloupe</h3>
                    <p className="text-white text-lg mb-2">{siteInfo.address}</p>
                    <p className="text-gray-300">
                      Consultations sur rendez-vous • Déplacements possibles dans toute la Guadeloupe
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
);
